import React, { useEffect } from 'react';

interface NumericInputProps {
    name: React.ReactNode;
    value?: number;
    onChange: (value: number) => void;
    readOnly?: boolean;
}

const NumericInput: React.FC<NumericInputProps> = ({ name, value = 0, onChange, readOnly }) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        if (newValue === '') {
            onChange(0);
        } else {
            const numericValue = parseFloat(newValue);
            if (!isNaN(numericValue)) {
                onChange(numericValue);
            }
        }
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.target.value === '0') {
            e.target.value = '';
        }
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        if (e.target.value === '') {
            e.target.value = '0';
            onChange(0);
        }
    };

    useEffect(() => {
        if (value === 0 || value === null) {
            onChange(0);
        }
    }, [value]);
    return (
        <div className='numericContainer'>
            <p className='nameOfNumericInput'>{name}:</p>
            <input
                className='numericInput k-input-solid'
                type="text"
                value={value === 0 ? 0 : Math.floor(value)}
                onChange={handleChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                step="1"
                min="0"
                readOnly={readOnly}
            />
        </div>
    );
};

export default NumericInput;
